export default __webpack_public_path__ + "bef390d9ab466a9e473616e4851d3a4b.png";